import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const secureStorage = {
  setItem(key, value) {
    localStorage.setItem(key, value);
  },
  getItem(key) {
    return localStorage.getItem(key);
  },
  removeItem(key) {
    localStorage.removeItem(key);
  }
};

const useGlobale = create(
  persist(
    (set) => ({
      authenticated_collecte: false,
      user: null,

      updateUserInfo: (updatedUserData) => {
        set(state => ({
          ...state,
          user: {
            ...state.user,
            ...updatedUserData
          }
        }));
      },

      login: async (credentials, user) => {
        try {
          const authData = {
            access: credentials.access,
            refresh: credentials.refresh
          };

          secureStorage.setItem('auth_tokens', JSON.stringify(authData));
          secureStorage.setItem('credentials', JSON.stringify(credentials));

          set({
            authenticated_collecte: true,
            user: user,
          });
        } catch (error) {
          console.error('Error during login:', error);
        }
      },

      logout: async () => {
        try {
          secureStorage.removeItem('auth_tokens');
          secureStorage.removeItem('credentials');
          set({
            authenticated_collecte: false,
            user: null,
          });
          // Redirection après le logout
          // window.location.href = '/login';
        } catch (error) {
          console.error('Error during logout:', error);
        }
      },

      checkAuth: async () => {
        try {
          const tokensString = secureStorage.getItem('auth_tokens');
          if (tokensString) {
            const tokens = JSON.parse(tokensString);
            set({ authenticated_collecte: !!tokens.access });
          } else {
            set({ authenticated_collecte: false, user: null });
          }
        } catch (error) {
          console.error('Error checking auth:', error);
          set({ authenticated_collecte: false, user: null });
        }
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);

export default useGlobale;